import { HttpClient } from '@angular/common/http';
import { LlaveService, FichaReferidos } from 'src/app/shared/services/llave.service';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {} from '@aws-amplify/ui-angular';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { CompanyRegistrationService } from 'src/app/auth/services/company-registration.service';
import { S3UrlService } from 'src/app/shared/services/s3-url.service';
import { environment } from 'src/environments/environment';
import {
  CupoRegistroService,
  CupoRegistroEstado,
  CupoRegistroConsumo,
  CupoSalidas,
} from '../../services/cupo-registro.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import { ExpuestosPoliticamenteService } from '../../../auth/services/expuestos-politicamente.service';
import { KycApiService, SanctionsCheckResult, CountryRisk, PepChileCheckResult } from '../../../auth/services/kyc-api.service';
import { ComentarioCompliance } from '../../interfaces/comentario-compliance';
import { EstadoCompliance } from '../../interfaces/estado-compliance';
import { Pagador } from '../../interfaces/pagador';
import { PagadorService } from '../../services/pagador.service';
import { UserService } from '../../services/user.service';
import { VariablesComplianceService } from '../../services/variables-compliance.service';
import { CreatePayerComponent } from '../payer/create-payer/create-payer.component';
import { CreateWalletModalComponent } from '../wallets-usuarios/create-wallet-modal/create-wallet-modal.component';
import {
  CreateDataUpdateRequestComponent,
  CreateDataUpdateRequestData,
} from '../data-update-requests-admin/create-data-update-request/create-data-update-request.component';
import { UserForRequest } from '../../interfaces/data-update-request.interface';
import { ComplianceDialogComponent } from './compliance-dialog/compliance-dialog.component';
import { firstValueFrom } from 'rxjs';
import {
  DepositoRetenido,
  DepositosRetenidosService,
} from '../../services/depositos-retenidos.service';
import { DepositosRetenidosDialogComponent } from '../depositos-retenidos-dialog/depositos-retenidos-dialog.component';

export interface Image {
  key: string;
  url: string;
}

@Component({
  selector: 'app-compliance-user',
  templateUrl: './compliance-user.component.html',
  styleUrls: ['./compliance-user.component.sass'],
})
export class ComplianceUserComponent implements OnInit {
  pepData: any = { data: { dataInfo: {} } };
  filePreviewType: 'image' | 'iframe' | null = null;
  // Modal preview state
  filePreviewUrl: SafeResourceUrl | SafeUrl | null = null;
  filePreviewName: string | null = null;
  filePreviewError: boolean = false;

  isS3Path(value: any): boolean {
    return typeof value === 'string' && value.includes('/');
  }

  async openFilePreview(url: string, name: string): Promise<void> {
    this.filePreviewError = false;
    this.filePreviewUrl = null;
    this.filePreviewType = null;
    this.filePreviewName = name;

    if (!url || typeof url !== 'string') {
      this.filePreviewError = true;
      return;
    }

    let finalUrl: string | null = null;
    if (url.startsWith('https://')) {
      finalUrl = url;
    } else {
      try {
        const docUrl = await this.companyRegistrationService.getDocument(url);
        finalUrl = docUrl.url;
      } catch (err) {
        this.filePreviewError = true;
        return;
      }
    }

    if (!finalUrl) {
      this.filePreviewError = true;
      return;
    }

    // Quitar query params para detectar extensión correctamente (S3 signed URLs)
    const urlWithoutParams = finalUrl.split('?')[0];
    if (/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(urlWithoutParams)) {
      this.filePreviewUrl = this.sanitizer.bypassSecurityTrustUrl(finalUrl);
      this.filePreviewType = 'image';
    } else {
      this.filePreviewUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
      this.filePreviewType = 'iframe';
    }
  }

  closeFilePreview(): void {
    this.filePreviewUrl = null;
    this.filePreviewName = null;
    this.filePreviewType = null;
    this.filePreviewError = false;
  }

  isImageFile(url: string): boolean {
    if (!url) return false;
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
  }
  isPlainObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  // Campos internos que nunca se muestran en el detalle genérico
  private hiddenKeys = new Set([
    'progress', 'id', 'userId', 'createdAt', 'updatedAt', 'isCompleted',
    '_format', '_processed_at', '_processedAt', '_auto_populated', '_autoPopulated',
  ]);

  // Campos de data4 que ya se muestran en el tab "Datos representante legal"
  private hiddenData4Keys = new Set([
    'ocrResult', 'ocr', 's3Keys', 's3_keys',
    'faceVerification', 'facial_verification', 'fotoPersona',
  ]);

  /**
   * Determina si un campo debe mostrarse en el renderizado genérico
   */
  shouldShowField(key: string, value: any, parentDataKey?: string): boolean {
    // Ocultar keys internos (empiezan con _)
    if (key.startsWith('_')) return false;
    // Ocultar keys de la lista negra general
    if (this.hiddenKeys.has(key)) return false;
    // Ocultar keys específicos de data4
    if (parentDataKey === 'data4' && this.hiddenData4Keys.has(key)) return false;
    // Ocultar valores vacíos
    if (value === null || value === undefined || value === '') return false;
    // Ocultar placeholders
    if (value === 'from_step1' || value === 'from_step1_selfie') return false;
    // Solo filtrar objetos planos cuando estamos DENTRO de un dataX (no a nivel top)
    if (parentDataKey && typeof value === 'object' && !Array.isArray(value)) return false;
    return true;
  }

  /**
   * Formatea el valor para mostrar en el detalle genérico
   */
  formatValue(key: string, value: any): string {
    if (value === true) return 'Sí';
    if (value === false) return 'No';
    return String(value);
  }

  /**
   * Filtra las keys de un objeto para el renderizado genérico
   */
  getVisibleKeys(obj: any, parentDataKey?: string): string[] {
    if (!obj || typeof obj !== 'object') return [];
    return Object.keys(obj).filter(k => this.shouldShowField(k, obj[k], parentDataKey));
  }

  formatKey(key: string): string {
    if (!key) return '';
    // Replace underscores with spaces first
    let result = key.replace(/_/g, ' ');
    // Split camelCase or PascalCase into words
    result = result.replace(/([A-Z])/g, ' $1');
    // Capitalize first letter, clean up double spaces
    result = result.replace(/\s+/g, ' ').trim();
    return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
  }

  expanded: { [key: string]: boolean } = {};

  toggleExpand(key: string): void {
    this.expanded[key] = !this.expanded[key];
  }
  /**
   * Post-VULN-01: el browser ya no firma URLs S3 directamente. Pide al
   * backend la URL pre-signed vía `S3UrlService`. La promesa se resuelve
   * tarde — los callers deben await o pre-cachear en propiedades.
   */
  async getS3FileUrl(key: string): Promise<string> {
    const url = await this.s3UrlService.getReadUrl(key);
    return url ?? '';
  }
  objectKeys = Object.keys;
  images: Image[] = [];
  id: string = '';
  user: any;

  /** Ficha de referidos. `null` mientras carga o si el usuario no tiene nada. */
  fichaReferidos: FichaReferidos | null = null;
  userEmail: string = '';
  fotoIdFrontal: string = '';
  fotoIdPosterior: string = '';
  mostarFrontal: boolean = true;
  idImagesLoaded: boolean = false;
  comentariosCompliance: ComentarioCompliance[] = [];
  estadosCompliance: EstadoCompliance[] = [];
  formCompliance: FormGroup | undefined;
  estadoComplianceBase: Object = {};
  pagadores: Pagador[] = [];
  sanctionsResult: SanctionsCheckResult | null = null;
  sanctionsLoading = false;
  sanctionsError: string | null = null;
  isCompany = false;
  isNewCompanyFlow = false;
  estatuto = '';
  documentoIdTributario = '';
  companyRegistration: any = {};
  companyData1: any = null; // Representante legal data from new flow
  companyData6: any = null; // Documentos requeridos from new flow
  selfieUrl: string = '';
  companySanctionsResult: SanctionsCheckResult | null = null;
  companySanctionsLoading = false;
  companySanctionsError: string | null = null;
  pepChileResult: PepChileCheckResult | null = null;
  pepChileLoading = false;
  pepChileError: string | null = null;

  // ── Cupo de registro (compliance) ───────────────────────────────────
  cupoEstado: CupoRegistroEstado | null = null;
  cupoConsumo: CupoRegistroConsumo | null = null;
  cupoSalidas: CupoSalidas | null = null;
  cupoLoading = false;
  cupoActionLoading = false;
  cupoError: string | null = null;

  /**
   * Mostramos el módulo si el usuario tiene un cupo (registro parcial).
   * Ocultamos SOLO cuando el backend dice explícitamente que no hay cupo
   * (`existe === false`). Así, si el shape trae `existe` truthy o lo
   * omite pero incluye `nivel`/`tope`, igual renderizamos (y con él, los
   * botones de bloquear/desbloquear).
   */
  get showCupoModule(): boolean {
    const e = this.cupoEstado;
    if (!e) return false;
    return e.existe !== false;
  }

  get cupoBloqueado(): boolean {
    return this.cupoEstado?.bloqueado === true;
  }

  /** `true` cuando el cliente sigue PRE-activo y hay consumo que mostrar. */
  get cupoConsumoAplica(): boolean {
    return this.cupoConsumo?.aplica === true;
  }

  get cupoPorcentaje(): number {
    const p = this.cupoConsumo?.porcentajeUtilizado;
    return typeof p === 'number' ? p : 0;
  }

  /** El consumo alcanzó o superó el tope (puede pasar por sobregiro). */
  get cupoLimiteSuperado(): boolean {
    const c = this.cupoConsumo?.consumido;
    const t = this.cupoConsumo?.tope;
    return typeof c === 'number' && typeof t === 'number' && t > 0 && c >= t;
  }

  /** Verde <70% · ámbar 70–99% · rojo ≥100%. */
  get cupoBarColor(): string {
    const p = this.cupoPorcentaje;
    if (p >= 100) return '#dc2626';
    if (p >= 70) return '#f59e0b';
    return '#16a34a';
  }

  /** Mensaje cuando el consumo no aplica (según `motivo`). */
  get cupoConsumoMensaje(): string {
    switch (this.cupoConsumo?.motivo) {
      case 'COMPLETO':
        return 'Registro aprobado, sin tope.';
      case 'SIN_CUPO':
        return 'El usuario no tiene cupo de registro.';
      case 'INACTIVO':
        return 'El cupo está desactivado.';
      default:
        return '';
    }
  }

  /** Formatea CLP como entero con separador de miles (es-CL), sin decimales. */
  formatCupoClp(value: number | null | undefined): string {
    if (value === null || value === undefined) return '—';
    return Math.round(value).toLocaleString('es-CL');
  }

  /**
   * Carga el estado del cupo y, si existe, su consumo. Sigue la lógica
   * del instructivo: si `existe === false` no se muestra el módulo; si
   * existe, se muestra el nivel/bloqueo y se consulta el consumo (que
   * puede venir `aplica: false` cuando el cliente ya no es PRE).
   */
  async loadCupoRegistro(usuarioId: number): Promise<void> {
    if (!usuarioId) return;
    this.cupoLoading = true;
    this.cupoError = null;
    this.cupoEstado = null;
    this.cupoConsumo = null;
    this.cupoSalidas = null;
    try {
      const estado = await this.cupoRegistroService.getEstado(usuarioId);
      this.cupoEstado = estado;
      if (estado?.existe) {
        // Consumo y salidas son complementarios: si alguno falla, igual
        // mostramos el estado (nivel/bloqueo/tope). Se piden en paralelo.
        try {
          this.cupoConsumo = await this.cupoRegistroService.getConsumo(usuarioId);
        } catch {
          this.cupoConsumo = null;
        }
        try {
          this.cupoSalidas = await this.cupoRegistroService.getSalidas(usuarioId);
        } catch {
          this.cupoSalidas = null;
        }
      }
    } catch (err: any) {
      if (err?.status === 403) {
        this.cupoError = 'No tenés permisos para ver el cupo de registro.';
      } else {
        this.cupoError =
          err?.error?.message ||
          err?.message ||
          'No se pudo cargar el cupo de registro.';
      }
    } finally {
      this.cupoLoading = false;
    }
  }

  /**
   * Bloquea el acceso al tope. Pide un motivo obligatorio (modal) y, tras
   * el bloqueo, refresca el estado para actualizar el badge.
   */
  async bloquearCupo(): Promise<void> {
    const usuarioId = this.user?.usuarioId;
    if (!usuarioId) return;
    const res = await Swal.fire({
      title: 'Bloquear acceso al tope',
      input: 'textarea',
      inputLabel: 'Motivo del bloqueo',
      inputPlaceholder: 'Explicá por qué se bloquea el acceso...',
      showCancelButton: true,
      confirmButtonText: 'Bloquear',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#c0392b',
      inputValidator: (v) =>
        !v || !v.trim() ? 'El motivo es obligatorio' : null,
    });
    if (!res.isConfirmed || !res.value) return;

    this.cupoActionLoading = true;
    try {
      const r = await this.cupoRegistroService.bloquear(
        usuarioId,
        res.value.trim(),
      );
      if (!r.ok) {
        await Swal.fire({
          icon: 'warning',
          title: 'No se pudo bloquear',
          text: r.message || 'El usuario no tiene cupo de registro.',
          confirmButtonColor: '#1e5a3f',
        });
        return;
      }
      await this.loadCupoRegistro(usuarioId);
      Swal.fire({
        icon: 'success',
        title: 'Acceso bloqueado',
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err?.error?.message || err?.message || 'No se pudo bloquear.',
        confirmButtonColor: '#1e5a3f',
      });
    } finally {
      this.cupoActionLoading = false;
    }
  }

  /** Desbloquea el acceso al tope y refresca el estado. */
  async desbloquearCupo(): Promise<void> {
    const usuarioId = this.user?.usuarioId;
    if (!usuarioId) return;
    const confirm = await Swal.fire({
      icon: 'question',
      title: '¿Desbloquear acceso al tope?',
      text: 'El usuario volverá a poder operar dentro de su tope.',
      showCancelButton: true,
      confirmButtonText: 'Desbloquear',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#1e5a3f',
    });
    if (!confirm.isConfirmed) return;

    this.cupoActionLoading = true;
    try {
      const r = await this.cupoRegistroService.desbloquear(usuarioId);
      if (!r.ok) {
        await Swal.fire({
          icon: 'warning',
          title: 'No se pudo desbloquear',
          text: r.message || 'El usuario no tiene cupo de registro.',
          confirmButtonColor: '#1e5a3f',
        });
        return;
      }
      await this.loadCupoRegistro(usuarioId);
      Swal.fire({
        icon: 'success',
        title: 'Acceso desbloqueado',
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err?.error?.message || err?.message || 'No se pudo desbloquear.',
        confirmButtonColor: '#1e5a3f',
      });
    } finally {
      this.cupoActionLoading = false;
    }
  }

  // ── Progreso del registro (nuevo flujo de empresa) ──────────────────

  /** Registro de la empresa: contiene `progress` e `isCompleted`. */
  get companyDocuments(): any {
    return this.companyRegistration?.data?.companyDocuments ?? null;
  }

  /** `true` cuando el backend marca el registro como completo (100%). */
  get isRegistrationComplete(): boolean {
    return this.companyDocuments?.isCompleted === true;
  }

  /**
   * ¿Mostramos el indicador de avance? Solo cuando hay un registro de
   * empresa con datos: `progress` con steps, o el flag `isCompleted` en
   * true. Para personas o empresas sin data (`companyRegistration = {}`),
   * `companyDocuments` es null y esto devuelve false → el banner no se
   * renderiza y no afecta el resto de la vista.
   */
  get hasRegistrationProgress(): boolean {
    if (this.isRegistrationComplete) return true;
    const progress = this.companyDocuments?.progress;
    return (
      !!progress &&
      typeof progress === 'object' &&
      Object.keys(progress).length > 0
    );
  }

  /**
   * Porcentaje de avance del registro del usuario.
   *  - Si el backend lo marca `isCompleted`, es 100%.
   *  - Si no, se calcula sobre los steps de `progress` que ya tienen
   *    información (`completed: true`) sobre el total de steps.
   */
  get registrationProgressPercent(): number {
    if (this.isRegistrationComplete) return 100;
    const progress = this.companyDocuments?.progress;
    if (!progress || typeof progress !== 'object') return 0;
    const steps = Object.values(progress) as Array<{ completed?: boolean }>;
    if (!steps.length) return 0;
    const done = steps.filter((s) => s?.completed === true).length;
    return Math.round((done / steps.length) * 100);
  }

  // ── Documentacion de la sociedad ────────────────────────────────────

  /**
   * Etiquetas de los documentos que guarda `data6`. Las claves son las que
   * escribe el paso de documentacion del registro de empresa.
   */
  private static readonly ETIQUETAS_DOCUMENTO: Record<string, string> = {
    escritura: 'Escritura de constitución',
    vigencia: 'Certificado de vigencia',
    carpetaTributaria: 'Carpeta tributaria',
    conservador: 'Inscripción Conservador de Bienes Raíces',
    diarioOficial: 'Publicación en Diario Oficial',
    eRut: 'e-RUT del SII',
  };

  /**
   * Documentos societarios presentes en `data6`, listos para listar.
   *
   * Se recorre el slot en vez de enumerar documentos a mano, que es como
   * estaba antes: asi aparecen tambien los que el formulario pide solo para
   * ciertos tipos de sociedad (Conservador, Diario Oficial) y los `extra_*`
   * que el operador puede haber solicitado. Antes esos quedaban guardados y
   * sin mostrar, o sea invisibles para quien aprueba.
   *
   * `data6` mezcla archivos con la declaracion PEP (`es_pep`, `pep_*`), asi
   * que se filtra por lo que parece una ruta de S3.
   */
  get documentosSociedad(): Array<{ key: string; label: string; s3Key: string }> {
    const data6 = this.companyData6;
    if (!data6 || typeof data6 !== 'object') return [];

    return Object.keys(data6)
      .filter((key) => {
        const value = data6[key];
        return typeof value === 'string' && value.includes('/');
      })
      .map((key) => ({
        key,
        label:
          ComplianceUserComponent.ETIQUETAS_DOCUMENTO[key] ??
          (key.startsWith('extra_')
            ? `Documento adicional (${key.replace('extra_', '')})`
            : key),
        s3Key: data6[key] as string,
      }));
  }

  /**
   * Analisis del e-RUT, si la empresa se registro con el flujo que lo pide.
   * Vive en `data4` junto al OCR y la verificacion facial.
   */
  get erutAnalisis(): any | null {
    return this.companyDocuments?.data4?.erut ?? null;
  }

  constructor(
private spinner: SpinnerService,
    private fb: FormBuilder,
    private varCompliance: VariablesComplianceService,
    private http: HttpClient,
    private _Activatedroute: ActivatedRoute,
    private cognito: CognitoService,
    private userService: UserService,
    private pagadorService: PagadorService,
    private dialog: MatDialog,
    private companyRegistrationService: CompanyRegistrationService,
    private sanitizer: DomSanitizer,
    private ExpuestosPoliticamenteService: ExpuestosPoliticamenteService,
    private kycApiService: KycApiService,
    private s3UrlService: S3UrlService,
    private router: Router,
    private cupoRegistroService: CupoRegistroService,
    private llaveService: LlaveService,
    private depositosRetenidos: DepositosRetenidosService,
  ) {
    this.loadUserEmail();
    this.getVariablesCompliance();
    this.id = this._Activatedroute.snapshot.paramMap.get('email') ?? '';
    this.loadUser();
  }

  reloadPagadores() {
    this.pagadorService.getPagadoresByUser(this.user.usuarioId).then((res) => {
      this.pagadores = res;
    });
  }

  /** Operador: habilita/deshabilita la creación de pagadores de este cliente. */
  async toggleCanAddPayers() {
    const enabled = !this.user?.canAddPayers;
    const confirm = await Swal.fire({
      icon: 'question',
      title: enabled
        ? '¿Habilitar creación de pagadores?'
        : '¿Deshabilitar creación de pagadores?',
      text: enabled
        ? 'El cliente podrá generar links y registrar pagadores.'
        : 'El cliente no podrá crear pagadores ni ver la sección.',
      showCancelButton: true,
      confirmButtonText: enabled ? 'Habilitar' : 'Deshabilitar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: enabled ? '#1e5a3f' : '#c0392b',
    });
    if (!confirm.isConfirmed) return;
    const ref = this.spinner.start();
    try {
      await this.userService.setCanAddPayers(this.id, enabled);
      this.user.canAddPayers = enabled ? 1 : 0;
      this.spinner.stop(ref);
      Swal.fire({
        icon: 'success',
        title: enabled
          ? 'Creación de pagadores habilitada'
          : 'Creación de pagadores deshabilitada',
        timer: 1600,
        showConfirmButton: false,
      });
    } catch (e: any) {
      this.spinner.stop(ref);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: e?.error?.message || 'No se pudo actualizar el permiso.',
        confirmButtonColor: '#1e5a3f',
      });
    }
  }

  async loadUser() {
    await this.userService
      .getUserData(this.id)
      .subscribe(async ({ user }: any) => {
        this.user = user;

        // La columna `llave` no viene en esta respuesta: la entidad `User` de
        // wallet-back no la tiene mapeada. Se pide aparte a NestJS.
        if (user?.usuarioId) {
          this.fichaReferidos = await this.llaveService.fichaCompliance(user.usuarioId);
        }
        this.isCompany = Boolean(this.user.tipoUsuarioID);
        this.loadCupoRegistro(this.user.usuarioId);
        this.pagadorService
          .getPagadoresByUser(this.user.usuarioId)
          .then((res) => {
            this.pagadores = res;
          });
        this.formCompliance = this.fb.group({
          esListaONU: new FormControl(
            {
              value: this.user.esListaONU,
              disabled: this.user.fuenteComplianceID === 2,
            },
            [Validators.required]
          ),
          politicamenteExpuesto: new FormControl(
            {
              value: this.user.esPoliticamenteExpuesto,
              disabled: this.user.fuenteComplianceID === 2,
            },
            [Validators.required]
          ),
          esRTP: new FormControl(
            {
              value: this.user.esRTP,
              disabled: this.user.fuenteComplianceID === 2,
            },
            [Validators.required]
          ),
        });
        // Para empresa: cargar companyRegistration ANTES de getIdImages
        if (this.isCompany) {
          try {
            this.companyRegistration =
              await this.companyRegistrationService.getRegistration(
                this.user.usuarioId
              );
            // Detectar nuevo flujo: tiene s3Keys en data4
            const data4 = this.companyRegistration?.data?.companyDocuments?.data4;
            this.isNewCompanyFlow = !!(data4?.s3Keys?.documentFront || data4?.s3Keys?.selfie);
            // Guardar datos del representante legal para mostrar en compliance
            // Nuevo flujo: data1 tiene los datos completos del rep legal
            // Flujo viejo: data4 tiene los datos completos (beneficiario final / rep legal)
            this.companyData1 = this.isNewCompanyFlow
              ? (this.companyRegistration?.data?.companyDocuments?.data1 || null)
              : (data4 || null);
            this.companyData6 = this.companyRegistration?.data?.companyDocuments?.data6 || null;
            // Auto-expandir todas las secciones
            const docs = this.companyRegistration?.data?.companyDocuments;
            if (docs) {
              Object.keys(docs).forEach(k => { this.expanded[k] = true; });
            }
          } catch (err) {
          }
        }
        this.getIdImages();
        this.checkUserSanctions();
        this.checkPepChile();
        if (this.isCompany) {
          this.checkCompanySanctions();
        }
      });
    if (!this.user) {
      return;
    }
    if (this.user.politicamenteExpuesto === 1) {
      const pepData = await this.ExpuestosPoliticamenteService.findOne(
        this.user.numeroId
      );
    }
  }
  async loadUserEmail() {
    const userInSession = await this.cognito.getUser();
    this.userEmail = userInSession.attributes.email;
  }

  async getVariablesCompliance() {
    [this.comentariosCompliance, this.estadosCompliance] = await Promise.all([
      this.varCompliance.getComentariosCompliance(),
      this.varCompliance.getEstadosCompliance(),
    ]);
  }

  async getIdImages() {
    this.idImagesLoaded = false;
    // Post-VULN-01: backend firma vía `s3UrlService.getReadUrl()`. Helper
    // local porque las URLs viejas se asignaban como string vacío cuando
    // la key no existía — mantenemos esa semántica.
    const signed = async (key: string | null | undefined): Promise<string> =>
      (await this.s3UrlService.getReadUrl(key)) ?? '';

    // Empresa con nuevo flujo: cargar imágenes del representante legal desde data4.s3Keys
    if (this.isCompany && this.isNewCompanyFlow) {
      const s3Keys = this.companyRegistration?.data?.companyDocuments?.data4?.s3Keys;
      if (s3Keys) {
        try {
          if (s3Keys.documentFront) {
            const res = await this.companyRegistrationService.getDocument(s3Keys.documentFront);
            this.fotoIdFrontal = res?.url || '';
          }
          if (s3Keys.documentBack) {
            const res = await this.companyRegistrationService.getDocument(s3Keys.documentBack);
            this.fotoIdPosterior = res?.url || '';
          }
          if (s3Keys.selfie) {
            const res = await this.companyRegistrationService.getDocument(s3Keys.selfie);
            this.selfieUrl = res?.url || '';
          }
        } catch (err) {
        }
      }
      // También cargar estatuto/documentoIdTributario legacy si existen
      if (this.user.estatuto) {
        this.estatuto = await signed(this.user.estatuto);
      }
      if (this.user.documentoIdTributario) {
        this.documentoIdTributario = await signed(this.user.documentoIdTributario);
      }
      this.idImagesLoaded = true;
      return;
    }

    // Empresa flujo viejo: cargar fotos via backend API con fallback
    if (this.isCompany && !this.isNewCompanyFlow) {
      const oldData4 = this.companyRegistration?.data?.companyDocuments?.data4;
      const data5 = this.companyRegistration?.data?.companyDocuments?.data5;
      const data7 = this.companyRegistration?.data?.companyDocuments?.data7;
      // Representante legal de data5 (puede tener keys diferentes a data4)
      const repLegal = data5?.representantes?.[0];

      // Helper: intenta cargar un documento probando múltiples keys en orden
      // Incluye compatibilidad con keys viejas (sin /) y nuevas (con /)
      const tryLoadDocument = async (...keys: (string | undefined | null)[]): Promise<string> => {
        const tried = new Set<string>();
        for (const key of keys) {
          if (!key || key === 'from_step1' || key === 'from_step1_selfie' || tried.has(key)) continue;
          tried.add(key);
          try {
            const res = await this.companyRegistrationService.getDocument(key);
            if (res?.url) return res.url;
          } catch {}

          // Intentar variante alternativa con/sin slash para compatibilidad
          let altKey = '';
          if (key.includes('/')) {
            // Key nueva con / → intentar sin / (formato viejo)
            altKey = key.replace('/', '');
          } else {
            // Key vieja sin / → intentar insertando / después del UUID
            const uuidMatch = key.match(/^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i);
            if (uuidMatch) {
              altKey = uuidMatch[1] + '/' + key.substring(uuidMatch[1].length);
            }
          }
          if (altKey && !tried.has(altKey)) {
            tried.add(altKey);
            try {
              const res = await this.companyRegistrationService.getDocument(altKey);
              if (res?.url) return res.url;
            } catch {}
          }
        }
        return '';
      };

      // Documento frontal: data4 -> representante legal (data5) -> user
      this.fotoIdFrontal = await tryLoadDocument(
        oldData4?.documento_frontal, repLegal?.documento_frontal, this.user.fotoIdfrontal
      );

      // Documento reverso: data4 -> representante legal (data5) -> user
      this.fotoIdPosterior = await tryLoadDocument(
        oldData4?.documento_reverso, repLegal?.documento_reverso, this.user.fotoIdPosterior
      );

      // Selfie: data7 -> data4.fotoPersona -> user.selfie
      this.selfieUrl = await tryLoadDocument(
        data7?.selfie, oldData4?.fotoPersona, this.user.selfie
      );

      if (this.user.estatuto) {
        this.estatuto = await signed(this.user.estatuto);
      }
      if (this.user.documentoIdTributario) {
        this.documentoIdTributario = await signed(this.user.documentoIdTributario);
      }
      this.idImagesLoaded = true;
      return;
    }

    // For users registered via dinamic-signup (cognitoId present, persona flow)
    if (this.user.cognitoId && this.user.tipoUsuarioID === 0) {
      if (this.user.fotoIdfrontal) {
        this.fotoIdFrontal = await this.companyRegistrationService
          .getDocument(this.user.fotoIdfrontal)
          .then((res) => res.url);
      }
      if (this.user.fotoIdPosterior) {
        this.fotoIdPosterior = await this.companyRegistrationService
          .getDocument(this.user.fotoIdPosterior)
          .then((res) => res.url);
      }
      if (this.user.selfie) {
        this.selfieUrl = await this.companyRegistrationService
          .getDocument(this.user.selfie)
          .then((res) => res.url);
      }
      this.idImagesLoaded = true;
      return;
    }

    // Legacy S3 signed URL flow
    if (this.isCompany) {
      if (this.user.estatuto) {
        this.estatuto = await signed(this.user.estatuto);
      }
      if (this.user.documentoIdTributario) {
        this.documentoIdTributario = await signed(this.user.documentoIdTributario);
      }
    }

    if (this.user.fotoIdfrontal) {
      const signedURLFrontal = await signed(this.user.fotoIdfrontal);
      if (signedURLFrontal) {
        this.http
          .get(signedURLFrontal, { responseType: 'blob' })
          .subscribe((response) => {
            const reader = new FileReader();
            reader.readAsDataURL(response);
            reader.onloadend = () => {
              this.fotoIdFrontal = reader.result as string;
            };
          });
      }
    }

    if (this.user.fotoIdPosterior) {
      const signedURLPosterior = await signed(this.user.fotoIdPosterior);
      if (signedURLPosterior) {
        this.http
          .get(signedURLPosterior, { responseType: 'blob' })
          .subscribe((response) => {
            const reader = new FileReader();
            reader.readAsDataURL(response);
            reader.onloadend = () => {
              this.fotoIdPosterior = reader.result as string;
            };
          });
      }
    }
    this.idImagesLoaded = true;
  }

  async checkUserSanctions() {
    if (!this.user?.nombre) return;
    const fullName = `${this.user.nombre} ${this.user.apellidos || ''}`.trim();
    this.sanctionsLoading = true;
    this.sanctionsError = null;
    try {
      this.sanctionsResult = await this.kycApiService.checkSanctions({
        fullName,
        firstName: this.user.nombre || undefined,
        lastName: this.user.apellidos || undefined,
        nationality: this.user.nacionalidad || this.user.paisResidencia || undefined,
        dateOfBirth: this.user.fechaNacimiento || undefined,
      });
      if (this.sanctionsResult?.hasMatches && this.formCompliance) {
        this.formCompliance.patchValue({ esListaONU: true });
        this.formCompliance.get('esListaONU')?.markAsTouched();
      }
    } catch (error: any) {
      this.sanctionsResult = null;
      this.sanctionsError = error?.message || 'Error al consultar listas de sanciones. Intente nuevamente.';
    } finally {
      this.sanctionsLoading = false;
    }
  }

  async checkCompanySanctions() {
    if (!this.user?.razonSocial) return;
    this.companySanctionsLoading = true;
    this.companySanctionsError = null;
    try {
      this.companySanctionsResult = await this.kycApiService.checkSanctions({
        fullName: this.user.razonSocial.trim(),
        nationality: this.user.paisResidencia || undefined,
      });
    } catch (error: any) {
      this.companySanctionsResult = null;
      this.companySanctionsError = error?.message || 'Error al consultar listas de sanciones para la empresa.';
    } finally {
      this.companySanctionsLoading = false;
    }
  }

  async checkPepChile() {
    if (!this.user?.numeroId || this.user.tipoId === 'VE') return;

    this.pepChileLoading = true;
    this.pepChileError = null;

    try {
      const apellidos = (this.user.apellidos || '').trim();
      const apellidoParts = apellidos.split(/\s+/);
      const fatherName = apellidoParts[0] || undefined;
      const motherName = apellidoParts.length > 1 ? apellidoParts.slice(1).join(' ') : undefined;

      this.pepChileResult = await this.kycApiService.checkPepChile({
        dni: this.user.numeroId,
        personType: this.isCompany ? 'legal' : 'natural',
        name: this.user.nombre || undefined,
        fatherName,
        motherName,
        nationality: this.user.nacionalidad || undefined,
        country: this.user.paisResidencia || undefined,
      });
      if (this.pepChileResult?.isPep && this.formCompliance) {
        this.formCompliance.patchValue({ politicamenteExpuesto: true });
        this.formCompliance.get('politicamenteExpuesto')?.markAsTouched();
      }
    } catch (error: any) {
      this.pepChileResult = null;
      this.pepChileError = error?.message || 'Error al consultar PEP Chile. Intente nuevamente.';
    } finally {
      this.pepChileLoading = false;
    }
  }

  openTab(url: string) {
    window.open(url, '_blank');
  }

  async ngOnInit() {}

  aproveCompliance() {
    const ref = this.spinner.start();
    this.userService
      .updateUserCompliance(this.user.email, this.userEmail, {
        comentarioCompliance: 0,
        estadoCompliance: 3,
      })
      .subscribe(
        async () => {
          this.loadUser();
          this.spinner.stop(ref);
          await Swal.fire({
            icon: 'success',
            title: 'Compliance actualizado',
            text: 'Se ha aprobado el usuario con éxito',
            showCancelButton: false,
            showDenyButton: false,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#1e5a3f',
          });
          // A1: los depósitos propios que se retuvieron mientras no estaba
          // aprobado no se acreditan solos; se ofrece asignarlos ahora.
          await this.ofrecerDepositosRetenidos();
          // Tras la aprobación ofrecemos al operador disparar el alta de
          // wallet Binance Link sin salir de la vista. La oferta sólo se
          // muestra si el usuario tiene los archivos KYC mínimos; si no,
          // queda silenciosa para no obligar al operador a cerrar un modal
          // que igual iba a fallar.
          await this.offerBinanceLinkCreation();
        },
        (err) => this.spinner.stop(ref)
      );
  }

  /**
   * A1: al aprobar al cliente, ofrece asignar los depósitos retenidos de su
   * propio documento (persona por `numero_id`, empresa por `rut_empresa`) desde
   * que se registró, y los que llegaron con el RUT de sus pagadores aprobados:
   * mientras el cliente no estaba aprobado, esos también se retenían (el dueño
   * tiene que poder recibir). Si no hay, no muestra nada; si la búsqueda falla,
   * siguen en "Transacciones sin asignar".
   */
  private async ofrecerDepositosRetenidos(): Promise<void> {
    const u: any = this.user;
    if (!u?.usuarioId) return;
    try {
      const documento = Number(u.tipoUsuarioID) === 1 ? u.rutEmpresa : u.numeroId;
      const propios = await this.depositosRetenidos.buscar(documento, u.created_at);
      const deSusPagadores = await this.depositosDeSusPagadores(u.usuarioId);
      const vistos = new Set<number>();
      const depositos = [...propios, ...deSusPagadores].filter((d) => {
        if (vistos.has(d.cartolaId)) return false;
        vistos.add(d.cartolaId);
        return true;
      });
      if (!depositos.length) return;
      const dialogo = this.dialog.open(DepositosRetenidosDialogComponent, {
        width: '760px',
        maxWidth: '95vw',
        data: {
          titulo: deSusPagadores.length
            ? 'Depósitos retenidos de este cliente y sus pagadores'
            : 'Depósitos retenidos de este cliente',
          usuarioIdDestino: u.usuarioId,
          destino: `la cuenta #${u.usuarioId}`,
          depositos,
        },
      });
      await firstValueFrom(dialogo.afterClosed());
    } catch {
      // La aprobación ya quedó hecha.
    }
  }

  /** Retenidos con el RUT de los pagadores aprobados y activos del cliente. */
  private async depositosDeSusPagadores(usuarioId: number): Promise<DepositoRetenido[]> {
    try {
      const pagadores = await this.pagadorService.getPagadoresByUser(usuarioId);
      const aprobados = (pagadores ?? []).filter(
        (p) =>
          p.activo &&
          Number(p.estadoComplianceID ?? p.estadoCompliance?.estadoID) === 3,
      );
      const listas = await Promise.all(
        aprobados.map((p) =>
          this.depositosRetenidos.buscar(
            Number(p.tipoUsuarioId) === 1 ? p.rutEmpresa : p.numeroId,
            p.created_at,
          ),
        ),
      );
      return listas.flat();
    } catch {
      return [];
    }
  }

  /**
   * Oferta post-aprobación: pregunta al operador si quiere arrancar el
   * flujo de creación de wallet Binance Link para el mismo cliente que
   * acaba de aprobar. Si acepta, hace fetch fresco del `UserWithWallet`
   * (necesario para el shape que espera `CreateWalletModalComponent`) y
   * abre el modal de creación. Si el usuario no tiene los archivos KYC
   * mínimos (foto frontal + selfie) la oferta no se muestra — el backend
   * va a rebotar el onboard igualmente con `missing[]`.
   *
   * No filtra por tipo de usuario (persona/empresa) en este flujo: el
   * operador acaba de validar el perfil manualmente, así que confiamos
   * en su criterio. El modal y el backend siguen aplicando sus propios
   * gates si la operación no aplica.
   */
  private async offerBinanceLinkCreation(): Promise<void> {
    // Binance Link deshabilitado: no ofrecemos crear la wallet tras aprobar.
    if (!environment.binanceLinkEnabled) return;
    const usuarioId = this.user?.usuarioId;
    if (!usuarioId) return;

    const hasFotoFrontal = typeof this.user?.fotoIdfrontal === 'string'
      && this.user.fotoIdfrontal.trim() !== '';
    const hasSelfie = typeof this.user?.selfie === 'string'
      && this.user.selfie.trim() !== '';
    if (!hasFotoFrontal || !hasSelfie) return;

    const offer = await Swal.fire({
      icon: 'question',
      title: '¿Crear wallet Binance Link ahora?',
      text: 'El cliente quedó aprobado. ¿Querés iniciar el flujo de creación de wallet Binance Link?',
      showCancelButton: true,
      confirmButtonText: 'Sí, crear ahora',
      cancelButtonText: 'Más tarde',
      confirmButtonColor: '#1e5a3f',
      cancelButtonColor: '#6b7280',
      reverseButtons: true,
    });
    if (!offer.isConfirmed) return;

    // Construimos el `UserWithWallet` a partir del `this.user` que YA
    // está cargado — el usuario recién aprobado no tiene subcuenta ni
    // wallet todavía (eso es lo que el modal va a crear), así que
    // llamar a `listUsersWithWallet` es innecesario y frágil: ese
    // endpoint puede no devolverlo (o devolver otro usuario) porque
    // está pensado para el LISTADO general de candidatos con/sin wallet.
    //
    // Todos los campos wallet-related quedan `null`. El modal detecta
    // eso y arranca en `DISABLED_NO_SUB` — estado exacto para el flujo
    // "Registrar subcuenta desde cero".
    const userWithWallet = this.buildUserWithWalletFromCompliance();

    const isMobile = window.innerWidth < 768;
    this.dialog.open(CreateWalletModalComponent, {
      data: { user: userWithWallet },
      panelClass: 'create-wallet-dialog',
      disableClose: false,
      autoFocus: false,
      maxWidth: isMobile ? '95vw' : '720px',
      minWidth: isMobile ? '90vw' : '640px',
      maxHeight: '92vh',
    });
  }

  /**
   * Convierte el `this.user` (shape del endpoint `getUserData`) al shape
   * `UserWithWallet` que espera `CreateWalletModalComponent`. Los campos
   * personales / KYC vienen del user cargado; los campos wallet-related
   * quedan `null` — es un usuario que recién fue aprobado y todavía no
   * tiene subcuenta creada.
   *
   * Normaliza `tipoUsuarioID` (CamelCase legacy) → `tipoUsuarioId`
   * (camelCase moderno del contrato Binance).
   */
  private buildUserWithWalletFromCompliance(): any {
    const u = this.user || {};
    const tipoUsuarioId =
      typeof u.tipoUsuarioId === 'number'
        ? u.tipoUsuarioId
        : typeof u.tipoUsuarioID === 'number'
          ? u.tipoUsuarioID
          : 0;
    return {
      // ── Datos base del usuario (todos vienen de `this.user`) ──
      usuarioId: u.usuarioId,
      email: u.email ?? this.userEmail ?? '',
      nombre: u.nombre ?? '',
      apellidos: u.apellidos ?? '',
      numeroId: u.numeroId ?? '',
      tipoId: u.tipoId ?? '',
      paisResidencia: u.paisResidencia ?? '',
      activo: u.activo ?? true,
      tipoUsuarioId,
      razonSocial: u.razonSocial ?? null,
      rutEmpresa: u.rutEmpresa ?? null,
      // ── KYC ──────────────────────────────────────────────────
      fechaNacimiento: u.fechaNacimiento ?? '',
      nacionalidad: u.nacionalidad ?? '',
      direccion: u.direccion ?? '',
      ciudadResidencia: u.ciudadResidencia ?? '',
      sexo: u.sexo ?? '',
      fechaExp: u.fechaExp ?? null,
      fotoIdfrontal: u.fotoIdfrontal ?? '',
      fotoIdPosterior: u.fotoIdPosterior ?? '',
      selfie: u.selfie ?? null,
      // ── Wallet — TODOS null: el modal va a crear la subcuenta ──
      walletId: null,
      subAccountId: null,
      subAccountEmail: null,
      walletStatus: null,
      kycStatus: null,
      lastBalanceBtc: null,
      lastBalanceUsdt: null,
      lastBalanceSyncedAt: null,
      lastDepositAt: null,
      totalDepositsCount: 0,
      walletCreatedAt: null,
      usdtBalance: null,
      approvedAt: u.approvedAt ?? new Date().toISOString(),
      prevalidation: null,
      // Snapshot de la deposit address TRC20 — null hasta que se cree
      // en el Paso 2 del modal. El campo se llama `walletTrc20` en la
      // interfaz (no `walletDepositAddress`); `applyStatus` del modal
      // lo consulta primero — si no lo seteamos como null explícito,
      // `undefined` haría fallar el check y arrancaría en un estado raro.
      walletTrc20: null,
    };
  }

  /**
   * Lleva al operador al dashboard de solicitudes de actualización
   * de datos. Útil para ver pendientes, vencidas, etc.
   */
  goToDataUpdateRequests(): void {
    this.router.navigate(['/wallet/admin/data-update-requests']);
  }

  /**
   * Abre el modal de creación de solicitud con el usuario actual ya
   * precargado — saltea el paso de búsqueda. Si la creación termina
   * con éxito, recargamos el detalle del usuario para reflejar el
   * cambio (e.g. badge "tiene solicitud activa").
   */
  openCreateDataUpdateRequestModal(): void {
    if (!this.user) return;

    // Pasamos el `this.user` casi tal cual (spread) — incluye los
    // campos de texto y los keys de archivos que el modal de creación
    // ya sabe leer del root (telefono, direccion, fotoIdfrontal, etc.).
    // Mapeamos sólo los campos canónicos por las dudas (compliance-user
    // usa `tipoUsuarioID` legacy y nosotros normalizamos a ambos).
    const initialUser: UserForRequest = {
      ...(this.user as any),
      usuarioId: this.user.usuarioId,
      email: this.user.email,
      nombre: this.user.nombre || '',
      apellidos: this.user.apellidos || '',
      numeroId: this.user.numeroId || '',
      tipoUsuarioId: (this.user.tipoUsuarioID === 1 ? 1 : 0) as 0 | 1,
      tipoUsuarioID: this.user.tipoUsuarioID,
      estadoComplianceId: this.user.estadoComplianceID,
      estadoComplianceID: this.user.estadoComplianceID,
      estadoCompliance: this.user.estadoCompliance,
    };

    const isMobile = window.innerWidth < 768;
    const ref = this.dialog.open<
      CreateDataUpdateRequestComponent,
      CreateDataUpdateRequestData,
      { created?: boolean }
    >(CreateDataUpdateRequestComponent, {
      data: { initialUser },
      maxWidth: isMobile ? '95vw' : '720px',
      minWidth: isMobile ? '90vw' : '320px',
      width: isMobile ? '95vw' : undefined,
      maxHeight: '90vh',
      autoFocus: false,
    });

    ref.afterClosed().subscribe((result) => {
      if (result?.created) {
        this.loadUser();
      }
    });
  }

  backlistUser() {
    const ref = this.spinner.start();
    this.userService
      .updateUserCompliance(this.user.email, this.userEmail, {
        comentarioCompliance: 0,
        estadoCompliance: 2,
      })
      .subscribe(
        (res) => {
          this.loadUser();
          Swal.fire({
            icon: 'success',
            title: 'Compliance actualizado',
            text: 'Se ha marcado el usuario como blacklist',
            showCancelButton: false,
            showDenyButton: false,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#1e5a3f',
          });
          this.spinner.stop(ref);
        },
        (err) => this.spinner.stop(ref)
      );
  }
  rejectUser() {
    this.dialog
      .open(ComplianceDialogComponent, {
        data: {
          userEmail: this.userEmail,
          user: this.user,
          comentariosCompliance: this.comentariosCompliance,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res === true) {
          this.loadUser();
        }
      });
  }
  guardarCompliance() {
    if (this.formCompliance?.invalid || !this.formCompliance?.touched) {
      return;
    }
    const ref = this.spinner.start();
    this.userService
      .updateUserChecks(
        this.user.email,
        this.userEmail,
        this.formCompliance.value
      )
      .subscribe(
        (res) => {
          Swal.fire({
            icon: 'success',
            title: 'Compliance actualizado',
            text: 'Se ha actualizado la información de compliance del usuario',
            showCancelButton: false,
            showDenyButton: false,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#1e5a3f',
          });
          this.loadUser();
          this.spinner.stop(ref);
        },
        (err) => this.spinner.stop(ref)
      );
  }

  openAddPayer() {
    this.dialog
      .open(CreatePayerComponent, {
        data: { email: this.id, id: this.user.usuarioId },
        height: '80%',
        width: '90%',
      })
      .afterClosed()
      .subscribe((res) => {
        if (res === true) {
          this.reloadPagadores();
        }
      });
  }
}
